import { useEffect, useState } from 'react';

// **********************************
// Utility
// **********************************

export const enterKey = 13;
export const escapeKey = 27;

export const isEnterKey = (e) => e.which === enterKey;
export const isEscapeKey = (e) => e.which === escapeKey;

// **********************************
// Helpers
// **********************************

export const getUpdatedSearchParams = (
  searchText,
  searchValue,
  searchParams,
) => {
  const params = [...searchParams];
  const query = {
    searchText: searchText,
    searchValue: searchValue,
  };

  const index = params.findIndex((e) => e.searchText === searchText);
  if (index === -1) {
    params.push(query);
  } else {
    if (searchValue !== '') {
      params[index].searchValue = searchValue;
    } else {
      params.splice(index, 1);
    }
  }

  return params;
};

export const clearSearchFields = () => {
  const searchFields = document.querySelectorAll('input[type=search]');
  Array.from(searchFields).forEach((input) => (input.value = ''));
};

// **********************************
// Hook
// **********************************

export const useTableSearch = ({
  onSearch,
  onClear,
  initialSearchParams = [],
  debugging = false,
}) => {
  const [searchParams, setSearchParams] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const noSearchValuesEntered = searchParams.length === 0;

  const handleSearch = () => {
    setIsSearching(true);
    if (debugging)
      console.log('useTableSearch > handleSearch', {
        isSearching,
        searchParams,
      });
    onSearch(searchParams);
  };
  const searchValueChange = (searchText, searchValue) => {
    const updatedParams = getUpdatedSearchParams(
      searchText,
      searchValue,
      searchParams,
    );
    setSearchParams(updatedParams);
  };

  const getDefaultValue = (searchParam) => {
    if (!initialSearchParams) return;
    const filtered = initialSearchParams?.filter(
      (data) => data.searchText === searchParam,
    );
    if (filtered.length > 0) return filtered[0].searchValue;
  };

  const clearInput = () => {
    setIsSearching(false);
    onSearch([]);
    setSearchParams([]);
    clearSearchFields();
    onClear();
  };

  const onKeyUp = (e) => {
    const atLeastOneSearchParamEntered = searchParams.length > 0;
    if (isEnterKey(e) && atLeastOneSearchParamEntered) onSearch(searchParams);
    if (isEscapeKey(e)) clearInput();
  };

  useEffect(() => {
    if (isSearching) setIsSearching(false);
  }, []);

  return {
    getDefaultValue,
    clearSearchValues: clearInput,
    handleSearch,
    isSearching,
    onSearchValueChanged: searchValueChange,
    onSearchValueKeyUp: onKeyUp,
    searchValuesEmpty: noSearchValuesEntered,
  };
};
